import * as Types from '../graphql.generated';

import { gql } from '@apollo/client';
export type Saved_Search_And_Alerts_FragmentFragment = {
    __typename?: 'SavedSearchAndAlerts';
} & Pick<Types.SavedSearchAndAlerts, 'uri'> & {
        currentFrequency?: Types.Maybe<
            { __typename?: 'AlertFrequencyOption' } & Pick<
                Types.AlertFrequencyOption,
                'i18NLabelKey' | 'value'
            >
        >;
    };

export const Saved_Search_And_Alerts_FragmentFragmentDoc = gql`
    fragment SAVED_SEARCH_AND_ALERTS_FRAGMENT on SavedSearchAndAlerts {
        uri
        currentFrequency {
            i18NLabelKey
            value
        }
    }
`;
